export const SPACING = [
  'spacing-4-xs',
  'spacing-3-xs',
  'spacing-2-xs',
  'spacing-xs',
  'spacing-s',
  'spacing-m',
  'spacing-l',
  'spacing-xl',
];
